<div class="eidos-filter-wrapper eidos-sliderrange-filter-wrapper">
  <p class="eidos-filter-label eidos-sliderrange-filter-label" *ngIf="config.label">{{ config.label }}</p>
  <eidos-input-slider width="100%"
    [min]="config.min" [max]="config.max" [(value)]="value" 
    [tooltip]="config.tooltip" (valueChange)="config.onValueChange"
    (onFocusIn)="(!!config.onFocusIn && config.onFocusIn())"
    (onFocusOut)="(!!config.onFocusOut && config.onFocusOut())"></eidos-input-slider>
</div>